export default __webpack_public_path__ + "static/media/Pass.ffa2ebcb.svg";